import { Component, Inject, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AddStudentDto } from '../../../../../../models/students/dto/AddStudentDto';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';
import { Lightbox } from 'ngx-lightbox';
import { Subject } from '../../../../../../models/subjects/subject';
import { SubjectService } from '../../../../../../services/subject/subject.service';
import { MY_FORMATS } from '../../../../../../const/date-format';
import { NoticiaDialogData } from './subject-noticia-data';
import { NoticiasService } from '../../../../../../services/noticias/noticias.service';
import { ConfigService } from './config.service';
import { Noticia } from '../../../../../../models/noticias/noticia';
import { TipoNoticiasService } from '../../../../../../services/tipo-noticias/tipo-noticia.service';
import { ImageService } from '../../../../../../services/images/image.service';
import { NoticiaMultimedia } from '../../../../../../models/multimedia-noticia/noticia-multimedia';
import { ToolbarService, LinkService, ImageService as SynImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';

import { enableRipple, L10n } from '@syncfusion/ej2-base';

L10n.load({
    "de-DE": {
        "richtexteditor": {
            alignments: "Alineaciones",
            justifyLeft: "Alinear a la izquierda",
            justifyCenter: "Centrar",
            justifyRight: "Alinear a la derecha",
            justifyFull: "Justificar",
            fontName: "Nombre de la fuente",
            fontSize: "Tamaño de la fuente",
            fontColor: "Color de la fuente",
            backgroundColor: "Color de fondo",
            bold: "Negrita",
            italic: "Cursiva",
            underline: "Subrayado",
            strikethrough: "Tachado",
            clearFormat: "Limpiar formato",
            clearAll: "Limpiar todo",
            cut: "Cortar",
            copy: "Copiar",
            paste: "Pegar",
            unorderedList: "Lista con viñetas",
            orderedList: "Lista numerada",
            indent: "Aumentar sangría",
            outdent: "Disminuir sangría",
            undo: "Deshacer",
            redo: "Rehacer",
            superscript: "Superíndice",
            subscript: "Subíndice",
            createLink: "Insertar enlace",
            openLink: "Abrir enlace",
            editLink: "Editar enlace",
            removeLink: "Eliminar enlace",
            image: "Insertar imagen",
            audio: "Insertar audio",
            video: "Insertar video",
            replace: "Reemplazar",
            numberFormatList: "Lista de formato numérico",
            bulletFormatList: "Lista de formato con viñetas",
            audioReplace: "Reemplazar",
            videoReplace: "Reemplazar",
            videoAlign: "Alinear",
            videoDimension: "Dimensión",
            audioRemove: "Eliminar",
            videoRemove: "Eliminar",
            audioLayoutOption: "Opción de diseño",
            videoLayoutOption: "Opción de diseño",
            align: "Alinear",
            caption: "Leyenda",
            remove: "Eliminar",
            insertLink: "Insertar enlace",
            display: "Mostrar",
            altText: "Texto alternativo",
            dimension: "Cambiar tamaño",
            fullscreen: "Maximizar",
            maximize: "Maximizar",
            minimize: "Minimizar",
            lowerCase: "Minúsculas",
            upperCase: "Mayúsculas",
            print: "Imprimir",
            formats: "Formatos",
            sourcecode: "Ver código",
            preview: "Vista previa",
            viewside: "Vista lateral",
            insertCode: "Insertar código",
            blockquote: "Cita en bloque",
            linkText: "Texto para mostrar",
            linkTooltipLabel: "Título",
            linkWebUrl: "Dirección web",
            linkTitle: "Ingrese un título",
            linkurl: "http://ejemplo.com",
            linkOpenInNewWindow: "Abrir enlace en una nueva ventana",
            linkHeader: "Insertar enlace",
            dialogInsert: "Insertar",
            dialogCancel: "Cancelar",
            dialogUpdate: "Actualizar",
            imageHeader: "Insertar imagen",
            audioHeader: "Insertar audio",
            videoHeader: "Insertar video",
            imageLinkHeader: "También puede proporcionar un enlace desde la web",
            audioLinkHeader: "También puede proporcionar un enlace desde la web",
            videoLinkHeader: "URL web",
            embedVideoLinkHeader: "URL de inserción de medios",
            mdimageLink: "Proporcione una URL para su imagen",
            imageUploadMessage: "Arrastre una imagen aquí o busque para subir",
            audioUploadMessage: "Arrastre un archivo de audio o busque para subir",
            videoUploadMessage: "Arrastre un archivo de video o busque para subir",
            imageDeviceUploadMessage: "Haga clic aquí para subir",
            audioDeviceUploadMessage: "Haga clic aquí para subir",
            videoDeviceUploadMessage: "Haga clic aquí para subir",
            imageAlternateText: "Texto alternativo",
            alternateHeader: "Texto alternativo",
            browse: "Buscar",
            imageUrl: "http://ejemplo.com/imagen.png",
            audioUrl: "https://ejemplo.com/audio.mp3",
            videoUrl: "https://ejemplo.com/video.mp4",
            webUrl: "URL web",
            embedUrl: "Código de inserción",
            imageCaption: "Leyenda",
            imageSizeHeader: "Tamaño de la imagen",
            videoSizeHeader: "Tamaño del video",
            imageHeight: "Altura",
            imageWidth: "Ancho",
            videoHeight: "Altura",
            videoWidth: "Ancho",
            textPlaceholder: "Ingrese texto",
            inserttablebtn: "Insertar tabla",
            tabledialogHeader: "Insertar tabla",
            tableWidth: "Ancho",
            cellpadding: "Espaciado interno de celdas",
            cellspacing: "Espaciado entre celdas",
            columns: "Número de columnas",
            rows: "Número de filas",
            tableRows: "Fila",
            tableColumns: "Columna",
            tableCellHorizontalAlign: "Alineación horizontal de celda",
            tableCellVerticalAlign: "Alineación vertical de celda",
            createTable: "Crear tabla",
            removeTable: "Eliminar tabla",
            tableHeader: "Fila de encabezado",
            tableRemove: "Eliminar tabla",
            tableCellBackground: "Fondo de celda",
            tableEditProperties: "Editar propiedades de tabla",
            styles: "Estilos",
            insertColumnLeft: "Insertar columna a la izquierda",
            insertColumnRight: "Insertar columna a la derecha",
            deleteColumn: "Eliminar columna",
            insertRowBefore: "Insertar fila antes",
            insertRowAfter: "Insertar fila después",
            deleteRow: "Eliminar fila",
            tableEditHeader: "Editar tabla",
            TableHeadingText: "Encabezado",
            TableColText: "Columna",
            imageInsertLinkHeader: "Insertar enlace",
            editImageHeader: "Editar imagen",
            editAudioHeader: "Editar audio",
            editVideoHeader: "Editar video",
            alignmentsDropDownLeft: "Alinear a la izquierda",
            alignmentsDropDownCenter: "Centrar",
            alignmentsDropDownRight: "Alinear a la derecha",
            alignmentsDropDownJustify: "Justificar",
            imageDisplayDropDownInline: "En línea",
            imageDisplayDropDownBreak: "Separar",
            tableInsertRowDropDownBefore: "Insertar fila antes",
            tableInsertRowDropDownAfter: "Insertar fila después",
            tableInsertRowDropDownDelete: "Eliminar fila",
            tableInsertColumnDropDownLeft: "Insertar columna a la izquierda",
            tableInsertColumnDropDownRight: "Insertar columna a la derecha",
            tableInsertColumnDropDownDelete: "Eliminar columna",
            tableVerticalAlignDropDownTop: "Alinear arriba",
            tableVerticalAlignDropDownMiddle: "Alinear al centro",
            tableVerticalAlignDropDownBottom: "Alinear abajo",
            tableStylesDropDownDashedBorder: "Bordes discontinuos",
            tableStylesDropDownAlternateRows: "Filas alternas",
            pasteFormat: "Pegar formato",
            pasteFormatContent: "Elija la acción de formato",
            plainText: "Texto sin formato",
            cleanFormat: "Limpiar",
            keepFormat: "Mantener",
            pasteDialogOk: "Aceptar",
            pasteDialogCancel: "Cancelar",
            fileManager: "Gestor de archivos",
            fileDialogHeader: "Explorador de archivos",
            formatsDropDownParagraph: "Párrafo",
            formatsDropDownCode: "Código",
            formatsDropDownQuotation: "Cita en bloque",
            formatsDropDownHeading1: "Encabezado 1",
            formatsDropDownHeading2: "Encabezado 2",
            formatsDropDownHeading3: "Encabezado 3",
            formatsDropDownHeading4: "Encabezado 4",
            fontNameSegoeUI: "Segoe UI",
            fontNameArial: "Arial",
            fontNameGeorgia: "Georgia",
            fontNameImpact: "Impact",
            fontNameTahoma: "Tahoma",
            fontNameTimesNewRoman: "Times New Roman",
            fontNameVerdana: "Verdana",
            numberFormatListNumber: "Número",
            numberFormatListLowerAlpha: "Alfa minúscula",
            numberFormatListUpperAlpha: "Alfa mayúscula",
            numberFormatListLowerRoman: "Romano minúscula",
            numberFormatListUpperRoman: "Romano mayúscula",
            numberFormatListLowerGreek: "Griego minúscula",
            bulletFormatListDisc: "Disco",
            bulletFormatListCircle: "Círculo",
            bulletFormatListSquare: "Cuadrado",
            numberFormatListNone: "Ninguno",
            bulletFormatListNone: "Ninguno",
            formatPainter: "Copiar formato",
            emojiPicker: "Selector de emojis",
            embeddedCode: "Código embebido",
            pasteEmbeddedCodeHere: "Pegue el código embebido aquí",
            emojiPickerTypeToFind: "Escriba para buscar",
            emojiPickerNoResultFound: "No se encontraron resultados",
            emojiPickerTrySomethingElse: "Intente con otra búsqueda",
            linkAriaLabel: "Abrir en nueva ventana",
            unsupportedImage: "Formato de archivo no compatible",
            mergecells: "Combinar celdas",
            verticalsplit: "Dividir verticalmente",
            horizontalsplit: "Dividir horizontalmente"
        }
    }

});

@Component({
    selector: 'fuse-add-noticia',
    templateUrl: './add-noticia.component.html',
    styleUrls: ['./add-noticia.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
        ToolbarService, LinkService, SynImageService, HtmlEditorService
    ],
    
    animations: fuseAnimations
})
export class AddNoticiaComponent implements OnInit, AfterViewInit {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    subjectFormGroup;

    subjectNameControl;
    publicadoControl;
    enportadaControl;
    subjectDescriptionControl;

    tipoNoticiaFormControl;

    public baseUri;


    editorConfig = {};


    multimedias: any[]= [];
    


    public tools: object = {
        items: ['Undo', 'Redo', '|',
            'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
            'SubScript', 'SuperScript', '|',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
            'Indent', 'Outdent', '|', 'CreateLink','CreateTable',
            'Image', '|', 'ClearFormat']
    };
    public quickTools: object = {
        image: [
            'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
    };

    public insertImageSettings: object = {
        // saveUrl: 'http://localhost:22424/api/images/uploadnoticia',
        // path: 'http://localhost:22424/images/',
        saveFormat: 'Base64'
    }
    tipoNoticias = [];



    constructor(
        @Inject(MAT_DIALOG_DATA) public data: NoticiaDialogData,
        public dialogRef: MatDialogRef<AddNoticiaComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        private noticiasService: NoticiasService,
        private tipoNoticiasService: TipoNoticiasService,
        private imageService: ImageService,
        private _configService: ConfigService
    ) {
        console.log('data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';

        this.editorConfig = _configService.editorConfig;
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        console.log(this.data.noticia);
        if (this.data.mode === 'view') {
            this.disable();
        }
    
        this.tipoNoticiasService.getAll().subscribe(e => {
            this.tipoNoticias = [...e];
            this.blockUI.stop();
        });
    }

    disable() {
        this.subjectFormGroup.get('subjectNameControl').disable();
        this.subjectFormGroup.get('subjectDescriptionControl').disable();
        this.subjectFormGroup.get('tipoNoticiaFormControl').disable();
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.subjectFormGroup = this.fb.group({
            subjectNameControl: ['', [Validators.required]],
            subjectDescriptionControl: ['', []],
            publicadoControl: [this.data.noticia.Publicado, []],
            enportadaControl: [this.data.noticia.EnPortada, []],
            tipoNoticiaFormControl: ['', []]
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        this.blockUI.start(this.translationService.savingChanges);
        // check si hay es simple y si hay otras noticias para esta opcion, informar que se pisaran las demas
        this.noticiasService.checkBeforeSave(this.data.noticia.TipoNoticiaId, this.data.noticia.Id).subscribe(response => {
            console.log(response);
            if (response == false) {
                if (this.data.mode === 'new') {
                    console.log('nuevo');
                    this.add();
                } else {
                    console.log('editar');
                    this.edit();
                }
            } else {
                this.blockUI.stop();
                this.sweetAlertService.question("Aviso","El tipo de noticia seleccionado solo admite una noticia. Ya existe una noticia activa y publicada. ¿Desea reemplazarla?", "Si", "No", () => {
                    if (this.data.mode === 'new') {
                        console.log('nuevo');
                        this.add();
                    } else {
                        console.log('editar');
                        this.edit();
                    }
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
        
    }

    add() {
        this.blockUI.start(this.translationService.savingChanges);
        const noticia = new Noticia();

        noticia.Titulo = this.data.noticia.Titulo;
        noticia.Resumen = this.data.noticia.Resumen ? this.data.noticia.Resumen : '';
        noticia.Texto = this.data.noticia.Texto;
        noticia.TipoNoticiaId = this.data.noticia.TipoNoticiaId;
        noticia.Multimedias = this.data.noticia.Multimedias;
        noticia.Publicado = this.data.noticia.Publicado;
        noticia.EnPortada = this.data.noticia.EnPortada;

        this.noticiasService.add(noticia).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.noticia.Id = response.Id;
                this.noticiasService.noticias.push(this.data.noticia);
                this.noticiasService.noticiasObject[this.data.noticia.Id] = this.data.noticia;
                this.dialogRef.close(this.data.noticia);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.new, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    edit() {
        this.blockUI.start(this.translationService.savingChanges);

        const noticia = new Noticia();

        noticia.Id = this.data.noticia.Id;
        noticia.Titulo = this.data.noticia.Titulo;
        noticia.Resumen = this.data.noticia.Resumen ? this.data.noticia.Resumen : '';
        noticia.Texto = this.data.noticia.Texto;
        noticia.TipoNoticiaId = this.data.noticia.TipoNoticiaId;
        noticia.Multimedias = this.data.noticia.Multimedias;
        noticia.Publicado = this.data.noticia.Publicado;
        noticia.EnPortada = this.data.noticia.EnPortada;

        this.noticiasService.edit(noticia).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.noticiasService.noticias.findIndex(st => st.Id === this.data.noticia.Id);
                console.log('valor index', index);
                console.log(this.noticiasService.noticias[index]);
                this.noticiasService.noticias[index] = this.data.noticia;
                this.noticiasService.noticiasObject[this.data.noticia.Id] = this.data.noticia;
                this.data.noticia.EnPortada = this.data.noticia.EnPortada;
                this.data.noticia.Publicado = this.data.noticia.Publicado;
                this.dialogRef.close(this.data.noticia);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.new, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    eliminar(multimedia: NoticiaMultimedia) {
        let rem = this.data.noticia.Multimedias.findIndex(a => a.Id === multimedia.Id);
        if (rem !== -1) {
            this.data.noticia.Multimedias.splice(rem, 1);
        }
    }

    uploadPhoto(event: any, tipo: number, portada: boolean) {
        console.log('FuseAddStudentComponent > uploadPhoto > event', event);
        const file = event.target.files[0];
        const maxFileSize = 1 * 1024 * 1024; // 1Mb
        console.log('FuseAddStudentComponent > uploadPhoto > maxFileSize', maxFileSize);
        console.log('FuseAddStudentComponent > uploadPhoto > file.zize', file.size);
        if (file.size > maxFileSize) {
            this.translationService.translate('ERRORS.MAXIMUM_SIZE_EXCEEDED', '1Mb', (res) => {
                this.sweetAlertService.error(this.translationService.success, res, null);
            });
            return;
        }
        this.blockUI.start();
        this.imageService.upload(file, 'this.data.student.id', 'profile').subscribe(response => {
            console.log('FuseAddStudentComponent > uploadPhoto > response', response);
            console.log(file)
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                
                if(portada == true) {
                    let rem = this.data.noticia.Multimedias.findIndex(a => a.EsPortada);
                    if (rem !== -1) {
                        this.data.noticia.Multimedias.splice(rem, 1);
                    }
                }

                let multimedia = new NoticiaMultimedia();
                multimedia.Titulo = portada==true?"Portada":file.name;
                multimedia.Url = response.FileName;
                multimedia.EsPortada = portada == true;
                this.data.noticia.Multimedias.push(multimedia);
                if (tipo === 1) {
                    // this.data.student.IdCardBack = response.FileName;
                } else {
                    // this.data.student.IdCardFront = response.FileName;
                }
                // this.data.student.UpdatedAt = new Date(Date.now());
                this.translationService.translate('LABELS.CORRECTLY_UPLOADED_FEMALE', this.translationService.photo, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    onImageUploadSuccess(args) { 
        console.log(args);
        // if (args.e.currentTarget.getResponseHeader('name') != null) {
        //     args.file.name = args.e.currentTarget.getResponseHeader('name');
        //     let filename: any = document.querySelectorAll(".e-file-name")[0];
        //     filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
        //     filename.title = args.file.name;
        // }
    } 

    onPublicadoChange(value: boolean) {
        this.data.noticia.Publicado = value
        // Puedes realizar otras acciones aquí si lo deseas
      }

      onPortadaChange(value: boolean) {
        this.data.noticia.EnPortada = value
        // Puedes realizar otras acciones aquí si lo deseas
      }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/components/add-noticia/add-noticia.component.ts